import React from 'react'

type Props = {}

export function component(props: Props) {
    return <div className="c-horizontal-rule" />
}
